import { ACTIVITY_FILTERS, type ActivityFilter } from '@alluzo/shared';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { PersonActivity } from '~/features/workspace/person/person-activity';

const search = z.object({ filter: z.enum(ACTIVITY_FILTERS as [ActivityFilter, ...ActivityFilter[]]).optional().catch(undefined) });

function ActivityRoute(): ReactElement {
  const { filter } = Route.useSearch();
  return <PersonActivity filter={filter ?? 'all'} />;
}

/** What a person did, and what was done to them, by day; ?filter= picks Entries, Team and role, or Access. */
export const Route = createFileRoute('/_app/business/people/$userId/activity')({ validateSearch: search, component: ActivityRoute });
